<template>
  <div>
    <div class="flex flex-col justify-end items-center w-full h-full font-heiti text-sm">{{title}}</div>
  </div>
</template>

<script>
// 页眉
export default {
  props: ['title']
}
</script>
